module.exports = __webpack_public_path__ + "img/primordial-jade-winged-spear.ee917b3a.webp";